import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { SafeHtml } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromRoot from '../../../reducers'
import { UserLocation } from 'spotlight-ui/app/models/user/location.model';
import { SelectedEngagement } from 'spotlight-ui/app/models/engage/selected-engagement.model';

@Component({
  selector: 'mobile-campaign-preview',
  templateUrl: './mobile-campaign-preview.component.html',
  styleUrls: ['./mobile-campaign-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class MobileCampaignPreviewComponent {
    @Input() templateHtml: SafeHtml;
    @Input() title: string;
    @Input() type: string = 'offer';
    @Input() rsvp: boolean;
    @Input() rsvpHtml: SafeHtml = '';
    @Input() noRsvpHtml: SafeHtml = '';
    @Input() loading: boolean;
    @Input() appPreviewOverride: string;
    @Input() mode: string = 'create';
    @Input() includeOperatorPhoto: boolean = true;
    @Input() selectedEngagement: any
    @Output() goBack = new EventEmitter<boolean>();
    public readOnlyUser$: Observable<boolean>;
    public location$: Observable<UserLocation>;
    public selectedEngagement$: Observable<SelectedEngagement>;

    constructor(private readonly store: Store<fromRoot.State>) {
      this.readOnlyUser$ = this.store.select(fromRoot.getReadOnlyUser);
      this.location$ = this.store.select(fromRoot.getSelectedLocation);
    }

    public send() {
      this.goBack.emit(true);
    }

}
